
export const Endereco = {
    id : 1,
    endereco : "Rua Senador Carlos Gomes de Oliveira, 1000 - 88104785 Distrito Industrial - São José, SC",
    link : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3535.4034593163997!2d-48.6542904!3d-27.612018499999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x952735f42f3d449d%3A0x5820c94b8a8c0728!2sR.%20Sen.%20Carlos%20Gomes%20de%20Oliveira%2C%201000%20-%20Distrito%20Industrial%2C%20S%C3%A3o%20Jos%C3%A9%20-%20SC%2C%2088104-785!5e0!3m2!1spt-BR!2sbr!4v1709143007455!5m2!1spt-BR!2sbr'
}
